import writing_logo from '../../../img/writing.png';
import cefalofotografo_portada from '../../../img/cefalofotografo.jpg';
import pdf_logo from '../../../img/pdf.png';
import goodreads_logo from '../../../img/goodreads-icon.png';

export default function Cefalofotografo(props) {

    let text_es = (<div>
            <img src={cefalofotografo_portada} class="article-img-centered-350" alt="cefalofotografo"/>
        <p></p>
        Hace unos años estuve realmente involucrado en la fotografía. Iba a todas partes con mi cámara e incluso hice un proyecto
        365, en el cual tomé, edité y publiqué una foto por día durante un año. Esta fue una gran enseñanza en mi camino. En algún momento,
        queriendo más que nada poder <b><i>regalar</i></b> mi fotografía de una manera tangible, publiqué un pequeño libro compilado de mi trabajo de esa época.
        Este libro se llama "Cefalofotógrafo" y se puede conseguir <a href="https://www.blurb.com/b/436741" target="_blank" rel="noreferrer">en este enlace.</a>
        <p></p>
        Ahora, no me interesa realmente que usted vaya y compre el libro en Blurb. Como decia, esto es un <b><i>regalo</i></b>. Dejo el libro completo
        en formato PDF para que lo puedan descargar y disfrutar.
        Haz click <a href="https://www.dropbox.com/scl/fi/qfsi35lxv2qlkpwpmil44/cefalofotografo-copia-Alf.pdf?rlkey=sbtj1pv38shamc1hjyqs5gcj5&st=wila1tlf&dl=0" target="_blank" rel="noreferrer">aquí <img src={pdf_logo} width="32px;" alt="PDF" /></a>. 
        <p></p>
        Por supuesto, este libro se encuentra disponible en
        <a href="https://www.goodreads.com/book/show/17567852-cefalofot-grafo" target="_blank" rel="noreferrer"> <img src={goodreads_logo} width="32px" alt="goodreads"/>.</a>
        </div>);
    let text_en = (<div>
            <img src={cefalofotografo_portada} className="article-img-centered-350" alt="cefalofotografo"/>
        <p></p>
        Some years ago, I was really involved in photography. I would go everywhere with my camera and even did a 365 project, in which I took,
        edited, and published a photo per day for a year. This was a great lesson on my journey. At some point, wanting more than anything to be able to
        <b><i> gift</i></b> my photography in a tangible way, I published a small book compiled from my work of that time.
        This book is called "Cefalofotógrafo" and can be found <a href="https://www.blurb.com/b/436741" target="_blank" rel="noreferrer">at this link.</a>
        <p></p>
        Now, I don't really care if you go and buy the book on Blurb. As I said, this is a <b><i>gift</i></b>. I'm leaving the complete book in PDF format for you to
        download if you feel like doing it.
        Click <a href="https://www.dropbox.com/scl/fi/qfsi35lxv2qlkpwpmil44/cefalofotografo-copia-Alf.pdf?rlkey=sbtj1pv38shamc1hjyqs5gcj5&st=wila1tlf&dl=0" target="_blank" rel="noreferrer">here <img src={pdf_logo} width="32px;" alt="PDF" /></a>.
        <p></p>
        Of course, this book is available on
        <a href="https://www.goodreads.com/book/show/17567852-cefalofot-grafo" target="_blank" rel="noreferrer"> <img src={goodreads_logo} width="32px" alt="goodreads"/>.</a>
        </div>);

    let text = text_es;
    
    switch(props.lang){
        case "en":
            text = text_en;
            break;
        default:
            break;
    }

    return( <article className='article' name='cefalofotografo'>
            <a href="https://www.blurb.com/b/436741" target="_blank" rel="noreferrer">
                <img src={writing_logo} width="32px" alt="writing"/>
            </a>
            <a href="https://www.dropbox.com/scl/fi/qfsi35lxv2qlkpwpmil44/cefalofotografo-copia-Alf.pdf?rlkey=sbtj1pv38shamc1hjyqs5gcj5&st=wila1tlf&dl=0" target="_blank" rel="noreferrer">
                <img src={pdf_logo} width="32px" alt="Download PDF"/>
            </a>
            <a href="https://www.goodreads.com/book/show/17567852-cefalofot-grafo" target="_blank" rel="noreferrer">
                <img src={goodreads_logo} width="32px" alt="goodreads"/>
            </a>
            {text}
        </article>);
}